export default {
  label: {
    tooltip: 'Rename',
    exportTooltip: 'Download components',
    titlePlaceholder: 'Give a title to your dashboard',
    chooseCardsTitle: 'Components',
    addCardTooltip: 'Add component',
  },
};
